import { UiVariationContainerModel } from "../../models";

export function mockUiVariationContainerModel({
    id = "variation-container-1234",
    type = "uiVariationContainer",
    locale = "en",
    content = mockUiVariationContainerModelContent()
}: Partial<UiVariationContainerModel> = {}): UiVariationContainerModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiVariationContainerModelContent =
    UiVariationContainerModel["content"];

export function mockUiVariationContainerModelContent({
    entryTitle = "Variation Container Example",
    featureFlagName = "Example Feature Flag",
    ...optionals
}: Partial<UiVariationContainerModelContent> = {}): UiVariationContainerModelContent {
    return {
        entryTitle,
        featureFlagName,
        ...optionals
    };
}
